import { isNil } from 'lodash';

import { defaultSpamDetectionConfigEditorOutput } from '../default-spam-detection-config-editor-output';
import { SpamDetectionConfigEditorOutput } from '../spam-detection-config-editor-output';
import { SpamDetectionConfigFormType } from '../spam-detection-config-form-type';

export const formToSpamDetectionConfigEditorOutput = (
  formType: SpamDetectionConfigFormType | undefined | null,
): SpamDetectionConfigEditorOutput => {
  if (isNil(formType)) {
    return defaultSpamDetectionConfigEditorOutput;
  }

  return {
    enabled: formType.enabled ?? false,
    instructions: (formType.instructions ?? '').trim(),
    spamDetectedMessage: (formType.spamDetectedMessage ?? '').trim(),
    spamFilteringPassedMessage: (formType.spamFilteringPassedMessage ?? '').trim(),
  };
};
